import { useEffect, useState } from 'react';

const useModal = (initialState = false) => {

	const [visible, setVisible] = useState(initialState)

	useEffect(() => {
		if (visible) {
			return document.getElementsByTagName('body')[0].style.overflow = 'hidden';
		}
		document.getElementsByTagName('body')[0].style.overflow = null
	}, [visible])

	useEffect(() => {
        return () => document.getElementsByTagName('body')[0].style.overflow = null
    }, [])

	function show() {
		setVisible(true)
	}

	function hide() {
		setVisible(false)
	}

	return {
		hide,
		show,
		visible,
	}
};

export default useModal;
